<template>
	<div class="mall-goods-container">
		<div class="mall-goods-detail">
			<!-- 返回按钮 -->
			<div class="back-bar">
				<el-button type="text" class="back-btn" @click="handleGoBack">
					<i class="el-icon-arrow-left"></i>
					返回
				</el-button>
			</div>

			<!-- 上方：商品信息 -->
			<div class="goods-info-section">
				<!-- 左侧：图片轮播 -->
				<div class="goods-gallery">
					<div class="main-image">
						<img :src="mainImage" :alt="goodsInfo.title" />
					</div>
				</div>

				<!-- 右侧：商品信息 -->
				<div class="goods-meta">
					<h1 class="goods-title">{{ goodsInfo.title }}</h1>
					<div class="goods-tags">
						<el-tag v-for="(tag, index) in goodsInfo.tags" :key="index" size="small" type="success" class="meta-tag">
							{{ tag }}
						</el-tag>
					</div>

					<div class="meta-list">
						<div class="meta-item">
							<span class="meta-label">商品价格：</span>
							<span class="meta-value">
								由于定制服务的独特性，价格将根据具体需求面议。我们会提供极具竞争力的报价，确保您获得高性价比的服务。
							</span>
						</div>
						<div class="meta-item">
							<span class="meta-label">所属类目：</span>
							<el-tag v-for="(cat, index) in goodsInfo.categories" :key="index" size="small" type="primary" class="meta-tag">
								{{ cat }}
							</el-tag>
						</div>
						<div class="meta-item">
							<span class="meta-label">交付时间：</span>
							<span class="meta-value highlight-text">
								根据项目的复杂程度和需求细节确定交付时间，在与您沟通确认后，我们会给出明确的时间承诺，确保按时交付。
							</span>
						</div>
						<div class="meta-item">
							<span class="meta-label">服务约定：</span>
							<span class="meta-value">
								在您表达定制意向后，我们将安排专业团队与您进行私下沟通，深入了解您的需求。通过线上线下相结合的方式，确保对您的期望有全面且精准的把握。
							</span>
						</div>
					</div>

					<!-- 联系我们 -->
					<!-- <div class="contact-box">
						<div class="contact-left">
							<i class="el-icon-phone-outline contact-icon"></i>
							<div class="contact-info">
								<div class="contact-label">联系我们</div>
								<div class="contact-phone">{{ goodsInfo.contactPhone || 'xxx（请填写联系方式）' }}</div>
							</div>
						</div>
						<el-button type="text" class="copy-btn" @click="handleCopyPhone">
							<i class="el-icon-document-copy"></i>
							复制信息
						</el-button>
					</div> -->

					<!-- 操作按钮 -->
					<div class="action-btns">
						<el-button type="primary" size="medium" class="consult-btn" @click="handleConsult">立即咨询</el-button>
					</div>
				</div>
			</div>

			<!-- 下方：服务详情 -->
			<div class="service-detail-section">
				<div class="section-header">
					<div class="section-tab active">服务详情</div>
				</div>
				<div class="detail-content">
					<p>
						我们致力于为全省住建领域企业提供全方位、个性化的企业风采与宣传定制服务。无论您是希望在湖北建设信息网等权威平台进行精准的企业品牌宣传投放，还是打造独立的企业网站，我们都能满足您的一切需求。
					</p>
					<p>
						凭借对住建行业的深入理解和丰富的品牌宣传经验，我们深知每个企业都有其独特的魅力与价值。因此，我们提供的定制服务将紧密围绕您企业的特点和目标受众，从策划到执行，为您量身打造专属的宣传方案。
					</p>
					<h3>企业风采定制</h3>

					<p>
						视觉标识强化：不仅仅展示企业 icon，还将围绕其进行视觉延伸，确保在所有宣传场景中都能形成强烈的视觉冲击，强化品牌记忆。
					</p>
					<p>
						深度信息挖掘：除了基础企业信息、核心价值观与文化理念，我们深入挖掘企业背后的故事，如创业历程中的艰辛与突破、团队成员的独特经历等，以更具情感共鸣的方式展现企业风采。
					</p>
					<p>
						企业实力全景展示：全面展示企业力量，从团队实力、技术与资源优势、企业规模与布局，到创新能力、行业影响力等方面，通过丰富多样的表现形式，如视频、动画、互动图表等，让受众全方位感受企业的强大实力。
					</p>

					<h3>企业宣传定制</h3>
					<p>
						平台精准投放：根据您的预算和目标受众，在湖北建设信息网等行业权威平台的首页头条、宣传专栏等核心位置，制定个性化的投放策略。从广告形式、内容呈现到投放时间，都将根据您的需求进行定制，确保精准触达目标客户群体。
					</p>
					<p>
						网页页面设计：为您打造独具特色的网页页面，无论是企业展示页、产品介绍页还是活动推广页，我们都将融合品牌元素与现代设计理念，注重用户体验，提升页面的吸引力与转化率。
					</p>
					<p>
						企业网站建设：提供一站式的企业网站定制服务，从网站架构规划、前端设计到后端开发，我们将打造一个功能完备、界面美观、易于维护的企业网站。不仅满足企业信息展示的需求，还将考虑到搜索引擎优化、移动端适配等因素，助力企业在互联网上获得更多曝光与流量。
					</p>

					<h3>核心优势</h3>
					<p>
						个性化定制：我们摒弃千篇一律的模板化服务，深入了解您的企业需求、目标受众和市场定位，为您量身定制专属的宣传方案，确保您的企业在众多竞争对手中脱颖而出。
					</p>
					<p>
						专业团队支持：我们拥有一支由资深设计师、文案策划、技术开发人员组成的专业团队，具备丰富的行业经验和创新能力。从创意构思到技术实现，我们将为您提供全方位的专业支持，确保项目的高质量交付。
					</p>
					<p>
						全方位服务：无论您需要单一的宣传页面设计，还是复杂的企业网站建设，我们都能提供一站式服务。涵盖品牌策划、设计制作、技术开发、上线推广以及后续维护等各个环节，让您无需为繁琐的流程担忧。
					</p>
					<p>
						长期合作保障：我们注重与客户建立长期稳定的合作关系，不仅在项目执行过程中提供优质服务，还将在项目交付后提供完善的售后服务。及时响应您的需求，为您的企业发展提供持续的支持与保障。
					</p>

					<h3>服务流程</h3>
					<p>
						需求沟通：您通过点击 “立即咨询”
						按钮与我们取得联系，我们的专业团队将与您进行深入沟通，了解您的企业情况、宣传目标、预算限制等详细需求。
					</p>
					<p>
						方案策划：根据您的需求，我们的策划团队将制定详细的定制方案，包括创意构思、设计草图、功能规划、时间进度表以及报价等内容，并与您进行进一步的沟通与确认。
					</p>
					<p>
						设计制作：在方案确认后，设计师和技术人员将按照既定方案进行设计制作。期间，我们将定期与您沟通项目进展，确保您对项目的每一个环节都了如指掌。
					</p>
					<p>
						审核修改：完成初稿后，我们将提交给您进行审核。您可以提出修改意见，我们将根据您的反馈进行调整优化，直至您满意为止。
					</p>
					<p>
						上线交付：在您确认最终方案后，我们将协助您完成项目的上线工作，并提供相关的培训与指导，确保您能够顺利使用。同时，我们还将为您提供一定期限的售后服务，保障项目的稳定运行。
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/**
	 * @description 商城商品详情页
	 */
	export default {
		name: 'MallGoodsDetail',
		data() {
			return {
				activeImageIndex: 0,
				goodsInfo: {
					title: '企业风采与宣传定制服务',
					images: [require('@/assets/mall/goods/goods-customized.png')],
					tags: ['企业风采'],
					categories: ['品牌宣传营销服务', '企业风采与宣传定制'],
					price: '400元/年',
					contactPhone: '1859234781'
				}
			}
		},
		computed: {
			mainImage() {
				return this.goodsInfo.images[this.activeImageIndex] || this.goodsInfo.images[0]
			}
		},
		methods: {
			// 返回上一页
			handleGoBack() {
				this.$router.back()
			},
			// 切换主图
			handleSwitchImage(index) {
				this.activeImageIndex = index
			},
			// 复制联系方式
			handleCopyPhone() {
				const phone = this.goodsInfo.contactPhone || ''
				if (!phone) {
					this.$message.warning('暂无联系方式')
					return
				}
				if (navigator.clipboard) {
					navigator.clipboard
						.writeText(phone)
						.then(() => {
							this.$message.success('复制成功')
						})
						.catch(() => {
							this.$message.error('复制失败')
						})
				} else {
					// 降级方案
					const input = document.createElement('input')
					input.value = phone
					document.body.appendChild(input)
					input.select()
					document.execCommand('copy')
					document.body.removeChild(input)
					this.$message.success('复制成功')
				}
			},
			// 立即咨询
			handleConsult() {
				// this.$message.info('咨询功能开发中')
			},
			// 加入购物车
			handleAddCart() {
				// this.$message.success('已加入购物车')
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/views/mall/goodsDetail/goodDetail.scss';
</style>
